// Copyright (c) 2026 Optimum Healthcare IT. All rights reserved.
// Author: Frank Scalzo <Optimum Healthcare IT>
// License: proprietary

// ---------------------------------------------------------------------------
// Primordia is the whole application.
// ---------------------------------------------------------------------------
// This file used to be the router for the EAMS app this repository was cloned
// from, with Primordia carved out at "/" and the old screens still mounted on
// /login, /dashboard, /companies, /users, /projects and others.
//
// Those routes were removed rather than left lying around, for three reasons:
//
//   1. They still answered. A tester following a stale bookmark, or simply
//      typing /dashboard, landed in the previous product instead of this one.
//   2. They carried a SECOND authentication path (BffAuthContext against a
//      separate API) alongside the Cognito gate Primordia uses. Two doors into
//      one deployment, only one of which has been reasoned about, is not a
//      thing to hand to testers.
//   3. Every build warning in the project came from that tree, which meant the
//      warning list was noise and nobody would notice a real one appearing.
//
// src/cmdb imports nothing from outside itself, so removing it was safe. The
// code is in git history if any of it is ever wanted back.
// ---------------------------------------------------------------------------

import React from 'react';
import CmdbApp from './cmdb/CmdbApp';

export default function App() {
  return <CmdbApp />;
}
